import script from "./TheHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHeader.vue?vue&type=script&setup=true&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=47fb8d14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47fb8d14"]])

export default __exports__